import React, { useState, useEffect } from 'react';
import { Box, Typography, Stack, IconButton, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import VisibilityIcon from '@mui/icons-material/Visibility';
import axios from '../../../../axios-order';
import { useLocation, useHistory } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IosShareIcon from '@mui/icons-material/IosShare';
import {
    Dialog,
    DialogContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import { LoadingButton } from '@mui/lab';
import excelIconImage from '../../../../asserts/images/excelicon.svg'


const currencyFormatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
});

const TdsPayableDashBoard = () => {
    const history = useHistory()
    const location = useLocation();
    const { items } = location.state || {};
    const [tdsData, setTdsData] = useState([]);
    const [tdsSectionWiseSummary, setTdsSectionWiseSummary] = useState([])
    const [netTotals, setNetTotals] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedSectionItem, setSelectedSectionItem] = useState(null)
    const [dialogTitle, setDialogTitle] = useState('');
    const [dialogRows, setDialogRows] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("");
    const [message, setMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState("");
    const [uploadingSectionMap, setUploadingSectionMap] = useState({});
    const [bulkChallanUploadLoading, setBulkChallanUploadLoading] = useState(false)



    useEffect(() => {
        getTdsPaybleDashBoardData();
    }, []);


    const getTdsPaybleDashBoardData = () => {
        const payLoadData = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            month_name: items.month_name
        };
        axios
            .post('/payable_table3_4', payLoadData)
            .then((res) => {
                if (res.data?.status) {
                    const data = res?.data?.records?.tds_liablity_dashboard_and_Summary
                    setTdsData(data?.first_summary);
                    setNetTotals({
                        total_net_gross_amount: data?.total_net_gross_amount,
                        total_net_tds: data?.total_net_tds,
                        total_tds_payable_amount_per_cws: data?.total_tds_payable_amount_per_cws,
                        total_difference_in_value: data?.total_difference_in_value
                    });
                    setTdsSectionWiseSummary(data?.sec_wise_summary);
                }
            })
            .catch((err) => console.error(err));
    };


    const handleViewTDSPayableDashboardData = (item) => {
        const section = item.section;
        const company_non_company = item.company_non_company
        const record = tdsSectionWiseSummary.find(item => item.hasOwnProperty(section))
        const data = record?.[section]?.[company_non_company]?.details || []

        setDialogTitle(`Section ${section}`);
        setSelectedSectionItem(item)
        setDialogRows(data);
        setOpenDialog(true);
    };


    const handleViewTDSLiabilityCalcultaion = () => {
        history.push({
            pathname: `/TdsLiabilityCalcutionData`,
            state: { items: items }
        })
    }

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarSeverity(severity);
        setResponseMessage(message);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity(snackbarSeverity);
        setResponseMessage("");
    };

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleDownloadReport = () => {
        const financial_year = localStorage.getItem('financial_year_26Q')
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `TDS Payable Reconciliation Report-${financial_year} ${items.month_name}.xlsx`;

        axios
            .post(`/get_payable_challan_recon_report`, {
                business_entity_id: localStorage.getItem("business_entity_id"),
                financial_year: financial_year,
                month : items.month_name
            })
            .then((res) => {
                downloadBase64File(contentType, res.data.file, filename);
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {

            })
    }


    const columns = [
        {
            field: 'sr_no',
            headerName: 'Sr. No.',
            width: 90,
            valueGetter: (params) => params.api.getRowIndex(params.id) + 1,
        },
        { field: 'section', headerName: 'Section', width: 100 },
        {
            field: 'company_non_company',
            headerName: 'Company/Non-Company',
            flex: 1,
        },
        {
            field: 'gross_amount',
            headerName: 'Gross Amount',
            flex: 1,
            valueFormatter: ({ value }) => currencyFormatter.format(value || 0),
        },
        {
            field: 'tds_payables',
            headerName: 'TDS Payables',
            flex: 1,
            valueFormatter: ({ value }) => currencyFormatter.format(value || 0),
        },
        {
            field: 'tds_payable_per_cws',
            headerName: 'TDS Payables - CWS',
            flex: 1,
            valueFormatter: ({ value }) => currencyFormatter.format(value || 0),
        },
        {
            field: 'difference',
            headerName: 'Difference',
            flex: 1,
            valueFormatter: ({ value }) => currencyFormatter.format(value || 0),
        },
        {
            field: 'challan_upload',
            headerName: 'Challan Upload',
            width: 200,
            renderCell: (params) => {
                const section = params.row.section;
                const company_non_company = params.row.company_non_company
                const isUploading = uploadingSectionMap[`${section}-${company_non_company}`];
                if (section === "Net Total") return null;

                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        {isUploading ? (
                            <CircularProgress size={20} />
                        ) : (
                            <Button
                                variant="outlined"
                                size="small"
                                component="label"
                                sx={{ textTransform: 'none' }}
                                endIcon={<IosShareIcon fontSize="small" />}
                            >
                                Upload
                                <input
                                    type="file"
                                    accept=".pdf"
                                    hidden
                                    onChange={(e) => handleSingleFileChange(e, section, company_non_company)}
                                />
                            </Button>
                        )}
                    </Box>
                );
            },
            sortable: false,
            filterable: false,
        },
        {
            field: 'tds_working',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => {
                const section = params.row.section;
                if (section === "Net Total") return null;
                return (
                    <IconButton color="primary" size="medium" onClick={() => handleViewTDSPayableDashboardData(params.row)}>
                        <VisibilityIcon fontSize="medium" />
                    </IconButton>
                );
            },
            sortable: false,
            filterable: false,
        },


    ];


    const handleSingleFileChange = (event, section, company_non_company) => {
        if (event.target.files?.[0]) {
            const fileData = event.target.files[0];
            setUploadingSectionMap((prev) => ({ ...prev, [`${section}-${company_non_company}`]: true }));
            const fileName = fileData.name;
            const reader = new FileReader();
            reader.readAsDataURL(fileData);
            reader.onload = function () {
                const fileValue = reader.result;
                const payLoadData = {
                    business_entity_id: localStorage.getItem('business_entity_id'),
                    section: section,
                    company_non_company: company_non_company,
                    file: fileValue,
                    month_name: items.month_name,
                    financial_year: localStorage.getItem('financial_year_26Q'),
                    document_name: fileName,
                    is_bulk_upload: false
                }
                axios.post('/upload_repository_in_recon', payLoadData)
                    .then((res) => {
                        if (res?.data?.status) {
                            handleSnackbarOpen(res?.data?.message, 'success')
                        } else {
                            handleSnackbarOpen(res?.data?.message, 'warning')
                        }
                    }).catch((err) => {

                    }).finally(() => {
                        setUploadingSectionMap((prev) => ({ ...prev, [`${section}-${company_non_company}`]: false }));
                    });
            };
            event.target.value = null;

        }

    };


    const handleFileChange = (event) => {
        if (event.target.files?.[0]) {
            const fileData = event.target.files[0];
            setBulkChallanUploadLoading(true)
            const fileName = fileData.name;
            const reader = new FileReader();
            reader.readAsDataURL(fileData);
            reader.onload = function () {
                const fileValue = reader.result;
                const payLoadData = {
                    business_entity_id: localStorage.getItem('business_entity_id'),
                    section: '',
                    file: fileValue,
                    month_name: items.month_name,
                    financial_year: localStorage.getItem('financial_year_26Q'),
                    document_name: fileName,
                    is_bulk_upload: true
                }
                axios.post('/upload_repository_in_recon', payLoadData)
                    .then((res) => {
                        if (res?.data?.status) {
                            handleSnackbarOpen(res?.data?.message, 'success')
                        } else {
                            handleSnackbarOpen(res?.data?.message, 'warning')
                        }
                    }).catch((err) => {

                    }).finally(() => {
                        setBulkChallanUploadLoading(false)
                    })
            };
            event.target.value = null;


        }

    };


    const dialogColumns = [
        {
            field: 'sr_no',
            headerName: 'Sr. No.',
            flex: 0.3,
            valueGetter: (params) => params.api.getRowIndex(params.id) + 1,
        },
        {
            field: 'company_non_company',
            headerName: 'Company Type',
            flex: 1,
            renderCell: () => selectedSectionItem?.company_non_company || '',
        },
        { field: 'name', headerName: 'Name of Party', flex: 1.5 },
        { field: 'pan', headerName: 'PAN No', flex: 1 },
        { field: 'bill_no', headerName: 'Invoice No', flex: 1 },
        {
            field: 'booking_date',
            headerName: 'Booking Date',
            flex: 1.2,
            valueFormatter: ({ value }) =>
                value ? new Date(value).toLocaleDateString() : '',
        },
        {
            field: 'net_gross_amount',
            headerName: 'Gross Amount',
            flex: 1.2,
            valueFormatter: ({ value }) => currencyFormatter.format(value),
        },
        {
            field: 'net_tds',
            headerName: 'TDS Payables',
            flex: 1.2,
            valueFormatter: ({ value }) => currencyFormatter.format(value),
        },
        {
            field: 'tds_payable_amount_per_cws',
            headerName: 'TDS Payable AS Per Cws',
            flex: 1.5,
            valueFormatter: ({ value }) => currencyFormatter.format(value),
        },
        {
            field: 'difference_in_value',
            headerName: 'Difference',
            flex: 1.2,
            valueFormatter: ({ value }) => currencyFormatter.format(value),
        },
        {
            field: 'associated_remark',
            headerName: 'Association Remarks',
            flex: 1.5,
        },
    ];
    


    const summaryRow = {
        id: 'summary-row',
        sr_no: '',
        section: 'Net Total',
        company_non_company: '', // Leave empty for summary
        gross_amount: netTotals.total_net_gross_amount || 0,
        tds_payables: netTotals.total_net_tds || 0,
        tds_payable_per_cws: netTotals.total_tds_payable_amount_per_cws || 0,
        difference: netTotals.total_difference_in_value || 0,
    };


    return (
        <Box sx={{ width: '100%', mx: 'auto', mt: 3 }}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                px={2}
                mb={4}
            >
                {/* Left - Back Button */}
                <Button
                    variant="contained"
                    size="medium"
                    color="primary"

                    onClick={handleViewTDSLiabilityCalcultaion}
                    sx={{ textTransform: 'none', fontWeight: 500 }}
                >
                    TDS Liabilities
                </Button>

                {/* Center - Heading */}
                <Stack direction="row" alignItems="center" spacing={1}>
                    {/* <AccountBalanceWalletIcon color="primary" /> */}
                    <Typography variant="h6" fontWeight={600}>
                        TDS Payable Dashboard ({localStorage.getItem('financial_year_26Q')} {items.month_name})
                    </Typography>
                </Stack>

                {/* Right - Deatails Button */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>

                    <LoadingButton
                        variant="contained"
                        size="medium"
                        color="primary"
                        component="label"
                        startIcon={<IosShareIcon />}
                        loading={bulkChallanUploadLoading}
                        sx={{ textTransform: 'none', fontWeight: 500 }}
                    >
                        <input
                            type="file"
                            accept=".pdf"
                            hidden
                            onChange={handleFileChange}
                        />
                        Bulk Upload
                    </LoadingButton>
                    <Button
                        variant="outlined"
                        endIcon={
                            <img
                                src={excelIconImage}
                                alt="Excel"
                                style={{ width: 20, height: 20 }}
                            />
                        }
                        color="success"
                        sx={{ textTransform: 'none', fontWeight: 600, marginLeft: 3 }}
                        onClick={handleDownloadReport}
                    >
                        Export
                    </Button>

                    <Button
                        variant="contained"
                        size="medium"
                        color="primary"
                        startIcon={<ArrowBackIcon />}
                        onClick={() => history.goBack()}
                        sx={{ textTransform: 'none', fontWeight: 500, marginLeft: 2 }}
                    >
                        Back
                    </Button>

                </div>
            </Stack>

            <DataGridPro
                autoHeight
                rows={[...tdsData, summaryRow]}
                columns={columns}
                getRowId={(row) => row.id || `${row.section}-${row.company_non_company}`}
                getRowClassName={(params) =>
                    params.id === 'summary-row' ? 'summary-row' : ''
                }

                hideFooterSelectedRowCount
                sx={{
                    backgroundColor: '#fff',
                    '& .MuiDataGrid-columnHeader': {
                        backgroundColor: '#607d8b',
                        color: '#fff',
                        fontWeight: 'bold',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#fafafa',
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#ffffff',
                    },
                    '& .summary-row': {
                        backgroundColor: '#f0f4c3',
                        fontWeight: 'bold',
                        '& .MuiDataGrid-cell': {
                            fontWeight: 600,
                            color: '#000000',
                        },
                    },
                }}
            />

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        overflow: 'hidden',
                    }
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        bgcolor: '#e3f2fd',
                        px: 2,
                        py: 1,
                        borderBottom: '1px solid #90caf9',
                    }}
                >
                    <Typography
                        variant="h6"
                        fontWeight={600}
                        sx={{ flexGrow: 1, textAlign: 'center', color: '#0d47a1' }}
                    >
                        {dialogTitle}
                    </Typography>
                    <IconButton onClick={() => setOpenDialog(false)} size="small">
                        <CloseIcon sx={{ color: 'red' }} />
                    </IconButton>
                </Box>

                <DialogContent sx={{ p: 3 }}>
                    <Box sx={{ height: 500 }}>
                        <DataGridPro
                            rows={dialogRows}
                            columns={dialogColumns}
                            getRowId={(row) => row.id}
                            sx={{
                                backgroundColor: '#fff',
                                '& .MuiDataGrid-columnHeader': {
                                    backgroundColor: '#607d8b',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                },
                                '& .MuiDataGrid-row:nth-of-type(odd)': {
                                    backgroundColor: '#fafafa',
                                },
                                '& .MuiDataGrid-row:nth-of-type(even)': {
                                    backgroundColor: '#ffffff',
                                },
                                '& .summary-row': {
                                    backgroundColor: '#f0f4c3',
                                    fontWeight: 'bold',
                                    '& .MuiDataGrid-cell': {
                                        fontWeight: 600,
                                        color: '#000000',
                                    },
                                },
                            }}
                        />
                    </Box>
                </DialogContent>
            </Dialog>

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={4500}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>

        </Box>
    );
};

export default TdsPayableDashBoard;
